//

document.addEventListener("scroll", (event) => {

  if(window.scrollY > 100) {
    document.querySelector(".header__logo").classList.add("hide")
  } else {
    document.querySelector(".header__logo").classList.remove("hide")
  }
  
});

// Create a class for the element
class VariantList extends HTMLElement {

  constructor() {
    super();

    this.variants = this.querySelectorAll(".lp-variant")
  }

  connectedCallback() {

    console.log("custom code loaded")
    document.querySelectorAll(".multi-column__item .button.button--lg").forEach((button) => {

      button.addEventListener("click", () => {


        document.querySelector(".shopify-section--featured-product").scrollIntoView({ behavior: "smooth" })
        setTimeout(() => {
          document.querySelector(button.dataset.variant).children[0].click()
        }, 600);
      })

    })

    this.variants.forEach((variant) => {
      variant.addEventListener("click", () => {

        this.variants.forEach((v) => {
          v.classList.remove("selected")
        })

        document.querySelector(".product-info__title.h2 a").innerText = variant.dataset.title
        document.querySelector(".product .product-info__buy-buttons input[name='id']").value = variant.dataset.variantId
        variant.classList.add("selected")

        fetch(window.Shopify.routes.root + `products/${variant.dataset.handle}?sections=api-product-gallery`)
          .then(res => res.json())
          .then((data) => {


            document.querySelector("product-gallery").outerHTML = data['api-product-gallery']
          })

        fetch(window.Shopify.routes.root + `products/${variant.dataset.handle}?sections=product-description-api`)
          .then(res => res.json())
          .then((data) => {


            document.querySelector(".product-info__block-item .metafield-rich_text_field").innerHTML = data['product-description-api']
          })
      })
    })

  }
}

customElements.define("variant-list", VariantList);

document.querySelectorAll("details").forEach((d) => {

  d.addEventListener("click", () => {

    document.querySelectorAll("details").forEach((det) => {

      if (det.open && det != d) { 
        det.open = false
      }
    })

    if (d.open) {
      d.open = true
    } else {
      d.open = false
    }
    
  })

})

let anchorlinks = document.querySelectorAll('a[href^="#"]')
 
for (let item of anchorlinks) { // relitere 
    item.addEventListener('click', (e)=> {
        let hashval = item.getAttribute('href')
        let target = document.querySelector(hashval)
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
        history.pushState(null, null, hashval)
        e.preventDefault()
    })
}


class ProductCardLP extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.addEventListener("click", () => {
      document.querySelector(".shopify-section--featured-product").scrollIntoView({ behavior: "smooth" })
      setTimeout(() => {
        document.querySelector(`div[data-handle="${this.dataset.handle}"]`).click()
      }, 600);
      
    })

  }

}

customElements.define("product-card-lp", ProductCardLP);
